import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "result-card" }
const _hoisted_2 = { class: "result-card__details" }
const _hoisted_3 = { class: "result-card__summary" }
const _hoisted_4 = { class: "result-card__summary-text" }
const _hoisted_5 = { class: "result-card__title" }
const _hoisted_6 = { class: "result-card__meta" }
const _hoisted_7 = { class: "result-card__content" }
const _hoisted_8 = { class: "result-card__fields" }

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { IColumnItem } from '@/interfaces/search/IQueryColumn';
import { ISearchResultItem } from '@/interfaces/search/ISearchResultItem';
import { useUtil } from '@/services/util-service';

const emptyFieldValue = "-";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResultCard',
  props: {
    result: {},
    columnConfig: {}
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
const visibleColumns = computed(() => {
  return Object.fromEntries(
    Object.entries(props.columnConfig).filter(([dataKey, config]) => {
      return config.visible && dataKey !== 'name';
    })
  );
});

const getColumnValue = (result: ISearchResultItem | undefined, dataKey: string): string | number => {
  if (!result) {
    return emptyFieldValue;
  }

  const value = result[dataKey];
  if (value == null) {
    return emptyFieldValue;
  }

  if (dataKey === "length" || dataKey === "width") {
    return typeof value === "number" ? `${useUtil().formatNumber(value)} meter` : emptyFieldValue;
  }

  if (Array.isArray(value)) {
    const values = value.filter((item) => item.trim() !== "");
    return values.length ? values.join(", ") : emptyFieldValue;
  }

  if (typeof value === "string") {
    return value.trim() ? value : emptyFieldValue;
  }

  return value;
};

const openDetails = (shipId: string | null | undefined) => {
  if (!shipId) {
    return;
  }

  router.push({ name: 'Details', params: { shipId: shipId } });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", _hoisted_1, [
    _createElementVNode("details", _hoisted_2, [
      _createElementVNode("summary", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.result?.name), 1 /* TEXT */),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.result?.launchDate), 1 /* TEXT */)
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "icon icon--arrow-down-bold" }, null, -1 /* HOISTED */))
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("dl", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleColumns.value, (config, dataKey) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "result-card__field",
              key: dataKey
            }, [
              _createElementVNode("dt", null, _toDisplayString(config.displayName) + ":", 1 /* TEXT */),
              _createElementVNode("dd", null, _toDisplayString(getColumnValue(_ctx.result, dataKey)), 1 /* TEXT */)
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _createElementVNode("button", {
          class: "button button--secondary result-card__button",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (openDetails(_ctx.result?.uuid)))
        }, " Läs mer ")
      ])
    ])
  ]))
}
}

})